/* SETTINGS */

var headerheight = 100,
    bannerheight = 26,
    mobilesearchheight = 47;

/* END SETTINGS */



$("#modal").click(function() {
    closeRightMenus();
    closeLeftMenus();
    $(".first_leftmenu").hide();
    closeModals();
  });



$(document).on("click", ".closeleft", function() {
  closeLeftMenus();
  $("#modal").click();
});

$(document).on("click",".cartclose",function(){
  closeRightMenus();
});

$(document).on("click",".en_gallery_link",function(){
  $('.enap-video-popup').hide();
  $('body').removeClass('overflowhidden');
  var video_id = $(this).attr('id');
  var id = video_id.split("_").pop();
  var src = $('#iframe'+id).attr('src');
  var src_url = '/pages/youtube-video?url=' + src;
  
  window.open(src_url, '_blank');
  
});

function closeLeftMenus(carefulclose) {
  $(".globalheader").removeClass("hover");
  $(".navoption.underlined").removeClass("underlined");
  $(".menuoption.opaque").removeClass("opaque");
  
  if(carefulclose) {
    var $leftmenu = $(".leftmenu:not(#leftmenu-"+carefulclose+")").hide();
    
    $(".leftmenuextra:not([owner='"+carefulclose+"'])").hide();
    $("#modal").hide();
    //$(".leftmenuproduct:not([owner='"+carefulclose+"'])").hide();    
  }
  else {
    $(".leftmenu").hide();
    $(".leftmenuextra").hide();
    $("#modal").hide();
    //$(".leftmenuproduct").hide();
  }
}

$(".carthover").hover(function(e) {
    if(e.type == "mouseleave")
      return false;
    if ($(window).width() > 480){
        $("#rightmenu").show();
    }

        
    //closeModals();
    closeLeftMenus();
               
    $(".globalheader").addClass("hover");
  });



function closeRightMenus() {
  $(".globalheader").removeClass("hover");
  $("#rightmenu").hide();
}


function closeModals() {
  $("#modal").hide();
}


function showLeftNavigation(children, navigation_key, navigation_val_key) {
  $(".leftmenuextra .submenu_title").html(null);
  
  if(typeof navigation_val_key != "undefined") {
    var menu_title = "<p>"+navigation_val_key.title+"</p>";
    var $menu_title = $('<div/>').html(menu_title).contents();
    $(".leftmenuextra .submenu_title").append($menu_title);
  }
  
  $(".leftmenuextra .content").html(null);

  $.each(children, function (index, obj) {
    var string = " \
	  <a href='"+obj.data.url+"'> \
        <div class='extramenuoption "+obj.type+" "+obj.data.weight+"'> \
          "+obj.title+"\
        </div> \
      </a>";

    var $string = $('<div/>').html(string).contents();
    $(".leftmenuextra .content").append($string);

    //"product"==obj.type&&$string.find(".extramenuoption").hover(function(t){if("mouseleave"==t.type)return!1;$(".leftmenuproduct .content").html(null);var e=" \t\t <div class='menuimage'> \t\t <a href='"+obj.data.url+"'> <img src='"+obj.data.image+"' /> </a> \t\t\t\t </div> \t\t <div class='menuinfo'> <h1>"+obj.data.title+"</h1> <h2 class='price'>"+obj.data.price+"</h2> <h4 class='prod-type'>"+obj.data.type+"</h4> </div> <div class='menuform'> <form action='/cart/add'> <input type='hidden' name='id' value='"+obj.data.vid+"' /> <input type='hidden' name='quantity' value='1' /> <input type='submit' name='button' class='add btn-main' value='Add to Bag' /> </form> </div>",a=$("<div/>").html(e).contents();$(".leftmenuproduct .content").append(a),$(".leftmenuproduct").show()});
  });

  var string = "<a><div class='extramenuoption goback bold' key='leftmenu-"+navigation_key+"'>Back</div></a>";		        
  var $string = $('<div/>').html(string).contents();
  $(".leftmenuextra .content").append($string);

  $(".leftmenuextra").find(".goback").click(function() {
    var key = $(this).attr("key");

    $(".leftmenuextra").hide();
    $("#"+key).show();
  });

  $(".leftmenuextra").show();
}



function updateMenuPositions(windowwidth) {
  var totop = headerheight + bannerheight;
  
  //console.log(totop);
  
  $("body").css("padding-top", totop);
  $(".leftmenu, .leftmenuextra, #rightmenu").css("top", totop);
  $(".leftmenu, .leftmenuextra, #rightmenu").css("height", "calc(100% - " + totop + "px)");
  
}
$(document).ready(function(){
  setTimeout(function() {
	$('.wc_review_top_title h1').text('REVIEWS');
    }, 3000);
});

$(document).on("mouseenter", ".imageslideshow", function() {
    var slideshowImageCount = $(this).children('img').length;
    if(slideshowImageCount > 1) {
      var delayTime = 100;
      var speed = 1000;
      for(var i = 2; i <= slideshowImageCount; i++) {
        if(i == 2) {
          $(this).children("img:nth-child("+(i - 1)+")").fadeOut('fast');
        } else {
          $(this).children("img:nth-child("+(i - 1)+")").delay(500).fadeOut('fast');
        }
        $(this).children("img:nth-child("+i+")").delay(delayTime).fadeIn();
        delayTime += speed;
      }
      $(this).children('img').delay(speed).fadeOut();
      $(this).children('img:first').delay(delayTime - 800).fadeIn();
    }
  });

  $(document).on("mouseleave", ".imageslideshow", function() {
    $(this).children("img").stop(true, true).hide();
    $(this).children("img:first").show();
  });

$(document).ready(function(){
  setTimeout(function() {

  $('.grid--view-items').each(function(){  
	
     // Cache the highest
     var highestBox = 0;  
     var highestBox_title = 0; 
     var  grid_sold_out = 0;
    
    $('.price', this).each(function(){

       // If this box is higher than the cached highest then store it
       if($(this).height() > grid_sold_out) {
         grid_sold_out = $(this).height(); 
      }
		
    });
    //alert(grid_sold_out);
    
    	$('.price',this).height(grid_sold_out);


     // Select and loop the elements you want to equalise
     $('.grid-view-item__image-wrapper', this).each(function(){

       // If this box is higher than the cached highest then store it
       if($(this).height() > highestBox) {
         highestBox = $(this).height(); 
      }
		
    });
    
		
     // Set the height of all those children to whichever was highest 
      $('.grid-view-item__image-wrapper',this).height(highestBox);
    
         $('.grid-view-item__title', this).each(function(){

           // If this box is higher than the cached highest then store it
           if($(this).height() > highestBox_title) {
             highestBox_title = $(this).height(); 
          }

        });


         // Set the height of all those children to whichever was highest 
          $('.grid-view-item__title',this).height(highestBox_title);

   });
    
       $('.cross-sell').each(function(){

         // Cache the highest
         var highest_Box = 0;      

        $('.xs-product-title', this).each(function(){

            
           // If this box is higher than the cached highest then store it
           if($(this).height() > highest_Box) {
             highest_Box = $(this).height(); 
          }

        });
         
         //alert(highest_Box);
         
        $('.xs-product-title',this).height(highest_Box);
     });

   
  
   
 }, 3000);
  
});


   
 




function toggleDiv(){
  

  if($('.custom-left-product-filter').css('display')== 'block'){
    
   
  
  		$('.custom-left-product-filter').css('display','none'); 			
  
  
  }else{
  	
    
  	$('.custom-left-product-filter').css('display','block');
  
  }

}


